// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3ZoXn","dragIcon":"Choice_dragIcon__1OKj5","left":"Choice_left__MrzU4","input":"Choice_input__3pHXd"};